import { memo, useCallback } from 'react';
import { BottomSheet } from '@betty/navigation';
import { Box, PressableIcon, Text } from '@betty/moonlight';
import { CommunityJackpotCardProps } from './CommunityJackpotCard.types';

function CommunityJackpotCard({
  label,
  info,
  children,
}: CommunityJackpotCardProps) {
  const onInfoPress = useCallback(() => {
    BottomSheet.open({
      namespace: 'common',
      type: 'Info',
      data: {
        text: info,
      },
    });
  }, [info]);

  return (
    <Box
      variant="outline-gradient"
      borderRadius="radius-400"
      gradient="borderAccent"
      paddingTop="space-200"
      paddingBottom="space-400"
      paddingHorizontal="space-600"
      centerContent
    >
      <Box
        position="absolute"
        top="-space-200"
        alignSelf="center"
        flexDirection="row"
        alignItems="center"
        gap="space-100"
        paddingHorizontal="space-100"
        backgroundColor="screenBackground"
      >
        <Text
          variant="overline"
          gradient="darkSurfaceAccent"
          textAlign="center"
        >
          {label}
        </Text>
        {info && (
          <PressableIcon
            name="info"
            gradient="accentBackground"
            width="space-600"
            height="space-600"
            onPress={onInfoPress}
          />
        )}
      </Box>
      {children}
    </Box>
  );
}

export default memo(CommunityJackpotCard);
